import { gql } from '@apollo/client';
import { FieldFieldsFragment } from '../fields';
import {
  CreatorFields,
  EditorFields,
  SchemaFieldsFragment,
} from '../fragments';

export const FunnelSettingFieldsFragment = gql`
  fragment FunnelSettingFields on FunnelSetting {
    defaultConversionRate
  }
`;

export const InspectSettingFieldsFragment = gql`
  fragment InspectSettingFields on InspectSetting {
    schemaInspectSettings {
      fields {
        ...FieldFields
      }
      schema {
        ...SchemaFields
      }
    }
  }
  ${FieldFieldsFragment}
  ${SchemaFieldsFragment}
`;

export const ReportSettingFieldsFragment = gql`
  fragment ReportSettingFields on ReportSetting {
    funnel {
      ...FunnelSettingFields
    }
    inspect {
      ...InspectSettingFields
    }
  }
  ${FunnelSettingFieldsFragment}
  ${InspectSettingFieldsFragment}
`;

export const MaxSeatsFieldsFragment = gql`
  fragment MaxSeatsFields on MaxSeats {
    maxSeats
    occupiedSeats
    availableSeats
  }
`;

export const MaxSchemasFieldsFragment = gql`
  fragment MaxSchemasFields on MaxSchemas {
    maxSchemas
    usedSchemas
    availableSchemas
  }
`;

const MTUPlanFeatureFragment = gql`
  fragment MTUPlanFeature on PlanFeature {
    display
    subFeatures
  }
`;

export const MTUPlanFieldsFragment = gql`
  fragment MTUPlanFields on MTUPlan {
    contractPeriod {
      start
      end
    }
    included {
      ...MTUPlanFeature
    }
    mtuLimit
    notIncluded {
      ...MTUPlanFeature
    }
    overageCharge
    refreshQuota {
      activeCount
      limit
    }
  }
  ${MTUPlanFeatureFragment}
`;

export const CustomerPlanFieldsFragment = gql`
  fragment CustomerPlanFields on CustomerPlan {
    maxSeats {
      ...MaxSeatsFields
    }
    maxSchemas {
      ...MaxSchemasFields
    }
    mtuPlan {
      ...MTUPlanFields
    }
  }
  ${MaxSchemasFieldsFragment}
  ${MaxSeatsFieldsFragment}
  ${MTUPlanFieldsFragment}
`;

export const AllowedDomainSettingFragment = gql`
  fragment AllowedDomainSettingFields on AllowedDomainSetting {
    allowedDomains
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
  }
  ${CreatorFields}
  ${EditorFields}
`;
